import React from 'react';
import { Briefcase } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { mockData } from '../data/mock';

export const Projects = () => {
  return (
    <section id="projects" className="py-20 bg-gradient-to-br from-[#1E4E9E]/5 via-white to-[#00B050]/5">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-6xl font-bold text-slate-900 mb-4">
            Our <span className="bg-gradient-to-r from-[#003366] via-[#339933] to-[#003366] bg-clip-text text-transparent">Projects</span>
          </h2>
          <p className="text-lg text-slate-600">
            Delivering impactful solutions across Timor-Leste
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {mockData.projects.map((project, index) => {
            const isEven = index % 2 === 0;
            return (
              <Card
                key={project.id}
                className="border-0 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 overflow-hidden group cursor-pointer bg-white"
              >
                {/* Project Image Placeholder */}
                <div 
                  className="relative h-48 overflow-hidden"
                  style={{ background: isEven ? 'linear-gradient(135deg, #1E4E9E, #00B050)' : 'linear-gradient(135deg, #00B050, #1E4E9E)' }}
                >
                  <div className="absolute inset-0 flex items-center justify-center bg-black/10">
                    <Briefcase className="w-16 h-16 text-white/80 group-hover:scale-125 transition-transform duration-300" />
                  </div>
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-white text-slate-900 hover:bg-white shadow-lg font-semibold">
                      {project.year}
                    </Badge>
                  </div>
                </div>

                <CardContent className="p-6">
                  <Badge className="mb-3 bg-[#74C65A] text-white hover:bg-[#003366] transition-colors duration-300">
                    {project.category}
                  </Badge>
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-[#003366] transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {project.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Note */}
        <div className="text-center mt-12">
          <p className="text-slate-500 italic">
            More project details and images will be added soon
          </p>
        </div>
      </div>
    </section>
  );
};